import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../ui/button';

export function PageHeader({ title, subtitle, showBack = false, actions }) {
  const navigate = useNavigate();

  return (
    <header 
      className="sticky top-0 z-40 bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/80 border-b border-border"
      role="banner"
    >
      <div className="container max-w-4xl mx-auto px-4 py-3">
        <div className="flex items-center gap-3">
          {showBack && (
            <Button
              variant="ghost"
              size="icon"
              onClick={() => navigate(-1)}
              aria-label="Volver a la página anterior"
              data-testid="back-button"
              className="shrink-0 focus-visible:ring-2 focus-visible:ring-primary"
            >
              <ArrowLeft size={20} aria-hidden="true" />
            </Button>
          )}
          <div className="flex-1 min-w-0">
            <h1 className="text-xl font-bold tracking-tight truncate" id="page-title">
              {title}
            </h1>
            {subtitle && (
              <p className="text-sm text-muted-foreground truncate" aria-live="polite">
                {subtitle}
              </p>
            )}
          </div>
          {actions && (
            <div className="flex items-center gap-2 shrink-0" role="toolbar" aria-label="Acciones de página">
              {actions}
            </div>
          )}
        </div>
      </div>
    </header>
  );
}

export default PageHeader;
